class Favourites {
  constuctor() {
    this.store = [];
  }

  set store(newArray) {
    if (newArray.length > 0) {
      localStorage.setItem("NVFavs", JSON.stringify(newArray)); //Set makes array uniq
    } else {
      localStorage.removeItem("NVFavs"); //Set makes array uniq
    }
  }

  get store() {
    return JSON.parse(localStorage.getItem("NVFavs") || "[]");
  }

  add(slug) {
    this.store = [...new Set(this.store.concat([slug]))]; //add to store
    this.markFavourited(slug);
    this.updateSummary();

    //dont show if theres smthing in store alrdy
    if (!window.preventFavouritedHintShowing && this.store.length == 1) {
      toastr.success(I18n.t("js.attractions.addedToFavouritedHint"), "", {
        timeOut: 2000,
      });
      window.preventFavouritedHintShowing = true;
    }
  }

  remove(slug) {
    this.store = this.store.filter((v) => v !== slug);
    this.unMarkFavourited(slug);
    this.updateSummary();
    window.preventFavouritedHintShowing = true;
  }

  toggle(slug) {
    if (this.contains(slug)) {
      this.remove(slug);
      return false;
    } else {
      this.add(slug);
      return true;
    }
  }

  clear() {
    this.store = [];
  }

  contains(slug) {
    return this.store.indexOf(slug) > -1;
  }

  markAllFavourited() {
    $(`.attraction-preview .fav-link`).removeClass("favourited"); //first reset all

    this.store.forEach((slug) => {
      this.markFavourited(slug);
    });
  }

  markFavourited(slug) {
    $(`.attraction-preview[data-href*='${slug}'] .fav-link`)
      .addClass("favourited")
      .find("i,svg")
      .removeClass("far")
      .addClass("fas");
  }

  markShowPage(slug) {
    const favLink = $(".show-toolbox .favourite-attraction");
    if (this.contains(slug)) {
      favLink.addClass("favourited");
    } else {
      favLink.removeClass("favourited");
    }
  }

  unMarkFavourited(slug) {
    $(`.attraction-preview[data-href*='${slug}'] .fav-link`)
      .removeClass("favourited")
      .find("i,svg")
      .removeClass("fas")
      .addClass("far");
  }

  updateSummary() {
    if (this.store.length > 0) {
      $("#favourited-attractions-summary").removeClass("d-none");
      $("#favourited-attractions-summary").addClass("d-flex");
      $("#favourited-attractions-summary .counter").html(this.store.length);
    } else {
      $("#favourited-attractions-summary").removeClass("d-flex");
      $("#favourited-attractions-summary").addClass("d-none");
    }
  }

  summaryPagePath() {
    return `${ENV.attractions_path_prefix[I18n.locale]}?${this.store
      .map((v) => `favourited[]=${v}`)
      .join("&")}`;
  }
}

window.FAVOURITES = new Favourites();
